import { useBackgroundQuery } from '@apollo/client/react';
import { Navigate } from 'react-router';
import { Fragment } from 'react';

import { Main } from 'src/components/Layout';
import {
  MigrationsTableContainer,
  MigrationsConnectContainer,
  MigrationsContextProvider,
  useMigrations,
} from 'src/containers/Migrations';
import { IntegrationTypeEnum } from 'src/graphql/schema';
import { IntegrationsDocument } from 'src/graphql/actions/integration/integrations.query';
import { usePageMeta } from 'src/hooks';
import { withSuspense } from 'src/hoc';

import type { IIntegrationsQuery } from 'src/graphql/actions/integration/integrations.query';

import { InfoModal, AlertMessage } from './ui';

const MigrationsMain = withSuspense(() => {
  const [queryRef] = useBackgroundQuery<IIntegrationsQuery>(IntegrationsDocument, {
    variables: {
      active: true,
      type: IntegrationTypeEnum.Oauth,
      perPage: 100,
    },
  });
  const { totalLegacyReposCount } = useMigrations();

  if (!totalLegacyReposCount) return <Navigate to="/" />;

  return (
    <Fragment>
      <MigrationsTableContainer queryRef={queryRef} />
      <MigrationsConnectContainer queryRef={queryRef} />
    </Fragment>
  );
});

const Migrations = () => {
  usePageMeta('Migrations');

  return (
    <Main title="Migrations" className="bg-background-secondary">
      <MigrationsContextProvider>
        <div className="container mx-auto min-h-full flex flex-col">
          <div className="mb-6 space-y-6">
            <AlertMessage />
            <div className="space-y-1">
              <div className="text-base font-semibold text-gray-700">Migrate to OAuth integrations</div>
              <p className="text-sm text-muted-foreground">
                Connect your SCM accounts using OAuth - a more secure, app-to-app authentication method. Select
                repositories below and migrate them individually or in bulk.
              </p>
            </div>
          </div>
          <MigrationsMain />
        </div>
        <InfoModal />
      </MigrationsContextProvider>
    </Main>
  );
};

export default Migrations;
